import { useMemo } from 'react';

import { useUserStorageItem } from '@/modules/userStorage';
import { useGetCommonStore } from '@/store';
import {
  BONUS_SEEN_IDENTIFIER,
  type IBonusLastSeenInfo,
} from '../lib/bonusSeenInfo';
import { hasUnseenBonus } from '../lib/isUnseenBonus';
import { useActiveBonusesTabStore } from './activeBonusesTabStore';

export const useHasUnreadBonus = (): boolean => {
  const useCommonStore = useGetCommonStore();
  const bonuses = useCommonStore.use.bonuses();
  const freespins = useCommonStore.use.freespins();

  const isActiveBonusesTabOpen = useActiveBonusesTabStore(
    (state) => state.isOpen
  );

  const { info, isAvailable, isLoading } =
    useUserStorageItem<IBonusLastSeenInfo>(BONUS_SEEN_IDENTIFIER);
  const lastSeenAt = info?.lastSeenAt
    ? new Date(info.lastSeenAt).getTime()
    : null;

  const hasUnread = useMemo(
    () =>
      hasUnseenBonus(bonuses, lastSeenAt) ||
      hasUnseenBonus(freespins, lastSeenAt),
    [bonuses, freespins, lastSeenAt]
  );

  if (!isAvailable || isLoading || isActiveBonusesTabOpen) return false;

  return hasUnread;
};
